import { Button, Field, Modal, errorMessage, useToast, ErrorNote } from "@corecrm/ui";
import { useState } from "react";
import { useApproveDeliverable, useRequestChanges } from "../api/queries";
import type { Deliverable } from "../api/types";

/** Approve, or request changes with a comment. Approving the last deliverable in a phase makes
    its payment milestone due. */
export function DeliverableActions({ deliverable: d, size }: { deliverable: Deliverable; size?: "sm" }) {
  const approve = useApproveDeliverable();
  const toast = useToast();
  const [changes, setChanges] = useState(false);
  return (
    <>
      <Button
        variant="primary"
        size={size}
        busy={approve.isPending}
        onClick={() =>
          approve.mutate(d.id, {
            onSuccess: () => toast(`Approved: ${d.title}`),
            onError: (e) => toast(errorMessage(e), "err"),
          })
        }
      >
        Approve
      </Button>
      <Button size={size} onClick={() => setChanges(true)}>
        Request changes
      </Button>
      {changes && <ChangesSheet deliverable={d} onClose={() => setChanges(false)} />}
    </>
  );
}

function ChangesSheet({ deliverable: d, onClose }: { deliverable: Deliverable; onClose: () => void }) {
  const request = useRequestChanges();
  const toast = useToast();
  const [comment, setComment] = useState("");
  return (
    <Modal
      title={`Request changes: ${d.title}`}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="primary"
            busy={request.isPending}
            disabled={!comment.trim()}
            onClick={() =>
              request.mutate(
                { id: d.id, comment: comment.trim() },
                {
                  onSuccess: () => {
                    toast("Sent. The team will revise it and send it back for approval.");
                    onClose();
                  },
                },
              )
            }
          >
            Send request
          </Button>
        </>
      }
    >
      <div className="stack">
        <Field label="What needs to change?">
          <textarea rows={5} value={comment} onChange={(e) => setComment(e.target.value)} />
        </Field>
        {request.error && <ErrorNote error={request.error} />}
      </div>
    </Modal>
  );
}
